module.exports = __webpack_public_path__ + "static/media/note.cb05a4a2.svg";